import React, { useMemo } from 'react';

import { TableCell } from '@material-ui/core';
import { ReactComponent as ArrowDownIcon } from 'assets/pics/arrowDownIcon.svg';
import { ReactComponent as ArrowUpIcon } from 'assets/pics/arrowUpIcon.svg';
import { ReactComponent as SortingIcon } from 'assets/pics/sortingIcon.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './CustomTableHeader.sass';

export const CustomTableHeader = ({
  title,
  updateKey,
  sortingObject,
  key,
  updateSorting,
  sorting = true,
}) => {
  const arrow = useMemo(() => {
    if (!sorting) return null;
    if (sortingObject.key === updateKey && sortingObject.direction === 'asc') {
      return <ArrowUpIcon />;
    }
    if (sortingObject.key === updateKey && sortingObject.direction === 'desc') {
      return <ArrowDownIcon />;
    }
    return <SortingIcon />;
  }, [sortingObject, updateKey]);
  return (
    <TableCell
      scope="row"
      key={key}
      className="data"
      onClick={() => {
        if (sorting) {
          updateSorting(updateKey);
        }
      }}>
      <div className={classNames({ 'sortable-header': sorting })}>
        <div className="text">{title || ''}</div> {arrow}
      </div>
    </TableCell>
  );
};
CustomTableHeader.propTypes = {
  title: PropTypes.string.isRequired,
  updateKey: PropTypes.string.isRequired,
  sortingObject: PropTypes.object.isRequired,
  key: PropTypes.string.isRequired,
  updateSorting: PropTypes.func.isRequired,
  sorting: PropTypes.bool,
};
CustomTableHeader.defaultProps = {
  sorting: true,
};
